module.exports = __webpack_public_path__ + "dist/assets/img/7.5bc398a3.svg";